import config from '@/config'
import api from '@/modules/api'

export default {
  namespaced: true,
  state: {
    show: false,
    rendered: false,
    resolve: null,
    reject: null,
    extraArguments: {}
  },
  getters: {
    visible: state => state.show,
    rendered: state => state.rendered,
    resolve: state => state.resolve,
    reject: state => state.reject,
    extraArguments: state => state.extraArguments
  },
  mutations: {
    setShow (state, show) {
      if (show && !state.rendered) {
        state.rendered = true
      }
      state.show = show
    },
    setExtraArguments (state, args) {
      state.extraArguments = args
    },
    resetExtraArguments (state) {
      state.extraArguments = {}
    },
    setCallbacks (state, callbacks) {
      state.resolve = callbacks.resolve
      state.reject = callbacks.reject
    },
    resetCallbacks (state) {
      state.resolve = null
      state.reject = null
    }
  },
  actions: {

    showGallery ({ commit }, extraArguments = {}) {
      return new Promise((resolve, reject) => {
        commit('setCallbacks', { resolve, reject })
        commit('setExtraArguments', extraArguments)
        commit('setShow', true)
      })
    },

    hideGallery ({ commit, getters }) {
      const { visible, resolve } = getters
      if (visible) {
        resolve()
        commit('resetExtraArguments')
        commit('resetCallbacks')
        commit('setShow', false)
      }
    },

    async uploadImage ({ commit, getters, dispatch, rootGetters }, imageData) {
      const { resolve, reject } = getters
      try {
        commit('setShow', false)
        const payload = Object.assign({}, getters.extraArguments, imageData)
        const response = await api.image.upload({
          ImageBase64Data: payload.image,
          Width: payload.width,
          Height: payload.height,
          Extension: payload.extension,
          Subscription_GUID: rootGetters.subscription.Subscription_GUID,
          IsContent: payload.IsContent
        })
        resolve(response)
        commit('resetExtraArguments')
        commit('resetCallbacks')
        // commit('setShow', false)
      } catch (err) {
        reject(err)
      }
    },

    async uploadImages ({ commit, getters, dispatch, rootGetters }, imageDataArray) {
      const { resolve, reject } = getters
      try {
        commit('setShow', false)
        const payload = Object.assign({}, getters.extraArguments)
        const response = await api.image.multipleUpload({
          Images: imageDataArray,
          Subscription_GUID: rootGetters.subscription.Subscription_GUID,
          IsContent: payload.IsContent
        })
        resolve(response)
        commit('resetExtraArguments')
        commit('resetCallbacks')
        // commit('setShow', false)
      } catch (err) {
        reject(err)
      }
    },

    deleteImage ({ commit, rootGetters }, imageData) {
      const payload = Object.assign({}, imageData, {Subscription_GUID: rootGetters.subscription.Subscription_GUID})
      return api.image.delete(payload)
    },

    fetchPixabayImages ({ commit }, payload) {
      const params = {
        ...payload.params,
        key: config.pixabay_key
      }
      return api.image.pixabay({ params })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/imageGallery.js